import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import '../styles/About.css';


const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="hero-section py-5 bg-gradient-success text-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <Badge bg="light" text="dark" className="mb-4 px-3 py-2 rounded-pill fw-bold">
                🌱 LA RÉVOLUTION AGRICOLE EST EN MARCHE
              </Badge>
              <h1 className="display-4 fw-bold mb-4">
                GUIRETTE : <span className="text-warning">L'Alliance Parfaite</span> entre 
                <span className="text-warning"> Terre et Technologie</span>
              </h1>
              <p className="lead mb-4 fs-5">
                Nous transformons l'agriculture traditionnelle en une entreprise <strong>high-tech performante et rentable</strong>. 
                Parce que votre terre mérite bien plus que des méthodes du passé.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section Fondateurs */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-5 mb-lg-0">
              <Badge bg="success" className="mb-3 px-3 py-2 rounded-pill">
                🚀 NOTRE HISTOIRE
              </Badge>
              <h2 className="display-6 fw-bold mb-4">
                Deux Visionnaires, <span className="text-success">Une Mission</span>
              </h2>
              <p className="fs-5 mb-4">
                En 2025, à Marseille, deux passionnés unissent leurs forces pour écrire 
                <strong> l'avenir de l'agriculture française</strong>.
              </p>
              
              <div className="founder-story">
                <p className="mb-4">
                  <strong>Pyrrus KOUDJOU</strong> et <strong>Erik Wagna</strong> ont observé le même constat alarmant : 
                  les agriculteurs français croulent sous les coûts de production et voient leur rentabilité s'effriter.
                </p>
                <p className="mb-4">
                  Leur réponse ? <span className="text-success fw-bold">GUIRETTE</span> - une solution qui allie 
                  <strong> l'expertise terrain et la puissance du digital</strong> pour redonner aux agriculteurs 
                  le contrôle de leur destin.
                </p>
                <div className="impact-stats">
                  <Row className="g-3">
                    <Col sm={4}>
                      <div className="text-center p-3 bg-light rounded-3">
                        <div className="h4 fw-bold text-success mb-1">7+</div>
                        <small className="text-muted">Ans d'expertise</small>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="text-center p-3 bg-light rounded-3">
                        <div className="h4 fw-bold text-success mb-1">19</div>
                        <small className="text-muted">Ans en IT</small>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="text-center p-3 bg-light rounded-3">
                        <div className="h4 fw-bold text-success mb-1">100%</div>
                        <small className="text-muted">Dédié agriculture</small>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <Row className="g-4">
                <Col md={6}>
                  <Card className="border-0 shadow-lg rounded-4 overflow-hidden h-100 founder-card">
                    <Card.Img 
                      variant="top" 
                      src="/images/pyrrus.png" 
                      className="founder-img"
                    />
                    <Card.Body className="text-center p-4">
                      <Badge bg="success" className="mb-2">ENTREPRENEUR</Badge>
                      <Card.Title className="h5 fw-bold mt-2">Pyrrus KOUDJOU</Card.Title>
                      <Card.Text className="text-muted">
                        Expert en digitalisation agricole<br />
                        Visionnaire des sols connectés
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="border-0 shadow-lg rounded-4 overflow-hidden h-100 founder-card">
                    <Card.Img 
                      variant="top" 
                      src="/images/eric.png" 
                      className="founder-img rounded-circle"
                    />
                    <Card.Body className="text-center p-4">
                      <Badge bg="primary" className="mb-2">EXPERT IT</Badge>
                      <Card.Title className="h5 fw-bold mt-2">Erik Wagna</Card.Title>
                      <Card.Text className="text-muted">
                        19 ans d'expérience IT<br />
                        Architecte des solutions tech
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission & Vision */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="g-5">
            <Col lg={6}>
              <Card className="border-0 shadow-sm rounded-4 h-100 mission-card">
                <Card.Body className="p-5">
                  <div className="icon-wrapper mb-4">
                    <div className="bg-success bg-opacity-10 rounded-circle p-3 d-inline-flex">
                      <span className="text-success fs-2">🎯</span>
                    </div>
                  </div>
                  <Badge bg="success" className="mb-3 px-3 py-2 rounded-pill">
                    NOTRE MISSION
                  </Badge>
                  <h3 className="h2 fw-bold mb-4">
                    Redonner du <span className="text-success">Pouvoir</span> à l'Agriculteur
                  </h3>
                  <p className="fs-5 mb-4">
                    <strong>Notre mission est claire : transformer chaque exploitation agricole en une entreprise high-tech performante.</strong>
                  </p>
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <span className="text-success fw-bold">✓</span> 
                      <strong> Optimisation des coûts</strong> - Réduction moyenne de 30% sur les intrants
                    </li>
                    <li className="mb-3">
                      <span className="text-success fw-bold">✓</span> 
                      <strong> Augmentation des rendements</strong> - Jusqu'à +40% de productivité
                    </li>
                    <li className="mb-3">
                      <span className="text-success fw-bold">✓</span> 
                      <strong> Prise de décision éclairée</strong> - Données en temps réel
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card className="border-0 shadow-sm rounded-4 h-100 vision-card">
                <Card.Body className="p-5">
                  <div className="icon-wrapper mb-4">
                    <div className="bg-warning bg-opacity-10 rounded-circle p-3 d-inline-flex">
                      <span className="text-warning fs-2">🚀</span>
                    </div>
                  </div>
                  <Badge bg="warning" text="dark" className="mb-3 px-3 py-2 rounded-pill">
                    NOTRE VISION
                  </Badge>
                  <h3 className="h2 fw-bold mb-4">
                    Leader Mondial de l'<span className="text-warning">Agriculture 4.0</span>
                  </h3>
                  <p className="fs-5 mb-4">
                    <strong>Devenir la référence incontournable de la digitalisation agricole en Europe et en Afrique.</strong>
                  </p>
                  <div className="vision-points">
                    <div className="d-flex align-items-start mb-3">
                      <span className="text-warning me-3 mt-1">🌍</span>
                      <div>
                        <strong>Agriculture connectée</strong>
                        <p className="text-muted mb-0">Des sols intelligents aux récoltes optimisées</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-3">
                      <span className="text-warning me-3 mt-1">💡</span>
                      <div>
                        <strong>Innovation permanente</strong>
                        <p className="text-muted mb-0">Anticiper les besoins de demain</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start">
                      <span className="text-warning me-3 mt-1">🤝</span>
                      <div>
                        <strong>Écosystème durable</strong>
                        <p className="text-muted mb-0">Des agriculteurs prospères, une planète préservée</p>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Valeurs */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center text-center mb-5">
            <Col lg={8}>
              <Badge bg="success" className="mb-3 px-3 py-2 rounded-pill">
                NOS VALEURS
              </Badge>
              <h2 className="display-5 fw-bold mb-3">
                L'ADN de <span className="text-success">GUIRETTE</span>
              </h2>
              <p className="lead">
                Ces principes guident chacune de nos actions et innovations
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {[
              {
                icon: "📈",
                title: "IMPACT MESURABLE",
                description: "Chaque solution doit apporter des résultats concrets et quantifiables pour l'agriculteur. Pas de promesses, que des preuves.",
                color: "success"
              },
              {
                icon: "⚡",
                title: "AUDACE TECHNOLOGIQUE",
                description: "Nous repoussons les limites du possible, osant l'innovation là où d'autres hésitent. L'agriculture mérite la pointe de la tech.",
                color: "primary"
              },
              {
                icon: "🔒",
                title: "INTÉGRITÉ TOTALE",
                description: "Transparence absolue, honnêteté radicale. La confiance de nos agriculteurs est notre capital le plus précieux.",
                color: "info"
              },
              {
                icon: "💎",
                title: "INNOVATION PRAGMATIQUE",
                description: "Des solutions simples pour des problèmes complexes. L'innovation au service du concret, pas de la complexité.",
                color: "warning"
              },
              {
                icon: "🎯",
                title: "DÉTERMINATION INFINIE",
                description: "Rien n'arrête un agriculteur qui cultive sa terre. Rien n'arrête GUIRETTE qui cultive des solutions.",
                color: "dark"
              },
              {
                icon: "🤝",
                title: "PARTENARIAT RÉEL",
                description: "Nous ne sommes pas des prestataires, mais des partenaires. Votre succès est notre succès.",
                color: "success"
              }
            ].map((value, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="border-0 shadow-sm rounded-4 h-100 value-card">
                  <Card.Body className="p-4 text-center">
                    <div className={`bg-${value.color} bg-opacity-10 rounded-circle p-3 d-inline-flex mb-3`}>
                      <span className={`text-${value.color} fs-1`}>{value.icon}</span>
                    </div>
                    <h5 className="fw-bold mb-3">{value.title}</h5>
                    <p className="text-muted mb-0">{value.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Final */}
      <section className="py-5 bg-dark text-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h2 className="display-6 fw-bold mb-4">
                Prêt à <span className="text-warning">Révolutionner</span> Votre Exploitation ?
              </h2>
              <p className="lead mb-4">
                Rejoignez les agriculteurs visionnaires qui ont déjà choisi 
                <strong className="text-warning"> LA SOLUTION GAGNANTE</strong>
              </p>
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-warning btn-lg px-4 gap-3 fw-bold">
                  🚀 DEMARRER MA TRANSFORMATION
                </button>
                <button 
                 className="btn btn-outline-light btn-lg px-4"
                 href="/contact">
                  📞 NOUS CONTACTER
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;